import { useEffect } from 'react';
import { useBrand } from '../theme/useBrand';

export function usePageTitle(title: string): void {
  const { shortName } = useBrand();
  useEffect(() => {
    document.title = `${title} · ${shortName}`;
  }, [title, shortName]);
}
